<div class="container" tabindex="0" cdkTrapFocus>
    <div class="d-flex gap-1-rem" style="justify-content: space-between;">
        <div class="stage">
        <span class="title">
            {{this.properties.location}}
        </span>
            <span class="description">
            Dirección
        </span>
        </div>

        <!-- <div class="stage">
        <span class="title">
            {{this.properties.postal_code}}
        </span>
            <span class="description">
            Código postal
        </span>
        </div> -->

      <div class="stage">
          <span class="title">
            {{ formatDate(this.properties.lastModification) }}
          </span>
        <span class="description">
              Última actualización
          </span>
      </div>
    </div> 

    <div class="buttons-container">
      <button 
        class="category-button air-button" 
        [class.active]="activeButton === 'air'"
        (click)="selectButton('air')">
        <img src="/assets/icons/air_button.svg" alt="Aire" class="button-icon" />
        <span>Aire</span>
      </button>
      
      <button 
        class="category-button noise-button" 
        [class.active]="activeButton === 'noise'"
        (click)="selectButton('noise')">
        <img src="/assets/icons/noise_button.svg" alt="Ruido" class="button-icon" />
        <span>Ruido</span>
      </button>
      
      <button 
        class="category-button humidity-button" 
        [class.active]="activeButton === 'humidity'"
        (click)="selectButton('humidity')">
        <img src="/assets/icons/humidity_button.svg" alt="Humedad" class="button-icon" />
        <span>Humedad</span>
      </button>
    </div>

    <!-- <div *ngIf="this.properties.type === 1" class="data-space" tabindex="0" cdkTrapFocus> -->
    <!-- <div  class="data-space" tabindex="0" cdkTrapFocus>

        <div class="container">

            <div class="stack-info">
                <div class="d-flex align-items-flex-start ">
                    <div class="circle" style="background-color: rgb(3, 3, 3);"></div>
                    <div>
                        <span class="description text ml-16">PM1  </span>
                    </div>
                </div>
                <div class="text">
                <span class="title">
                    {{this.properties.psi}}</span>
                <span class="description">
                    μg/m3N
                </span>
                </div>
            </div>

            <div class="stack-info">
                <div class="d-flex align-items-flex-start ">
                    <div class="circle" style="background-color: #00FFFF;"></div>
                    <div>
                        <span class="description text ml-16">PM2.5  </span>
                    </div>
                </div>
                <div class="text">
                <span class="title">
                    {{this.properties.pm25}}
                </span>
                <span class="description">
                    μg/m3N
                </span>
                </div>
            </div>

            <div class="stack-info">
                <div class="d-flex align-items-flex-start ">
                    <div class="circle" style="background-color: #00B050;"></div>
                    <div>
                        <span class="description text ml-16">PM10  </span>
                    </div>
                </div>
                <div class="text">
                <span class="title">
                    {{this.properties.pm10}}
                </span>
                <span class="description">
                    μg/m3N
                </span>
                </div>
            </div>

            <div class="stack-info">
                <div class="d-flex align-items-flex-start ">
                    <div class="circle" style="background-color: #FF3300;"></div>
                    <div>
                        <span class="description text ml-16">NO2  </span>
                    </div>
                </div>
                <div class="text">
                <span class="title">
                    {{this.properties.no2}}
                </span>
                <span class="description">
                    μg/m3N
                </span>
                </div>
            </div>


            <div class="stack-info">
                <div class="d-flex align-items-flex-start ">
                    <div class="circle" style="background-color: #9A0000;"></div>
                    <div>
                        <span class="description text ml-16">CO  </span>
                    </div>
                </div>
                <div class="text">
                <span class="title">
                    {{this.properties.carbonDioxide}}
                </span>
                <span class="description">
                    μg/m3N
                </span>
                </div>
            </div>

            <div class="stack-info">
                <div class="d-flex align-items-flex-start ">
                    <div class="circle" style="background-color: #FFCC00;"></div>
                    <div>
                        <span class="description text ml-16">O3  </span>
                    </div>
                </div>
                <div class="text">
                <span class="title">
                    {{this.properties.o3}}
                </span>
                <span class="description">
                    μg/m3N
                </span>
                </div>
            </div>

            <div class="stack-info">
                <div class="d-flex align-items-flex-start ">
                    <div class="circle" style="background-color: #00B050;"></div>
                    <div>
                        <span class="description text ml-16">SO2  </span>
                    </div>
                </div>
                <div class="text">
                <span class="title">
                    {{this.properties.so2}}
                </span>
                <span class="description">
                    μg/m3N
                </span>
                </div>
            </div>

            <div class="stack-info">
                <div class="d-flex align-items-flex-start ">
                    <div class="circle" style="background-color: #0000002f;"></div>
                    <div>
                        <span class="description text ml-16">Temperatura  </span>
                    </div>
                </div>
                <div class="text">
                <span class="title">
                    {{this.properties.temperature}}
                </span>
                <span class="description">
                    °C
                </span>
                </div>
            </div>

            <div class="stack-info">
                <div class="d-flex align-items-flex-start ">
                    <div class="circle" style="background-color: #00000033;"></div>
                    <div>
                        <span class="description text ml-16">Humedad  </span>
                    </div>
                </div>
                <div class="text">
                <span class="title">
                    {{this.properties.humidity}}
                </span>
                <span class="description">
                    %
                </span>
                </div>
            </div>





        </div>

    </div> -->

    <div class="indicators-container" *ngIf="filteredIndicators.length > 0">
        <!-- Botón fijo "Bueno" solo para Aire -->
        <div class="air-quality-status-card" *ngIf="activeButton === 'air'">
            <div class="status-content">
                <div class="status-icon">
                    <sit-icon [icon]="Icon.AirQualityGood" [sizeClass]="'icon-size-18'" class="d-flex"></sit-icon>
                </div>
            </div>
        </div>
        <sit-air-quality-indicators
            *ngFor="let item of filteredIndicators"
            [properties]            = "item"
            [active]                = "item.indicatorName === ActiveIndicator?.name"
            (IndicatorDispatcher)   = "ChangeIndicator($event)"
        >
        </sit-air-quality-indicators>
    </div>
<!-- TODO unlock clause when data available -->
    <div class="graph" *ngIf="ActiveIndicator && dataGraphicList && dataGraphicList.data && dataGraphicList.data.length > 0">
        <span class="title">
            {{currentGraphDescription || this.ActiveIndicator?.indicatorName}}
        </span>
        <span class="label">
            Medida
        </span>
        <div class="d-flex full-width speed-range-chart">
            <sit-chart-line
                    [properties]="dataGraphicList"
                    [colorScale]="colorScale"
                    style="width: 100%; height: 13rem"
            >
            </sit-chart-line>
        </div>
    </div> 

    <ng-container *ngIf="ActiveIndicator?.ranges.length > 0" tabindex="0" cdkTrapFocus>

      <div class="ranges">
        <div class="title-range">
            <span class="title">
                Rangos
            </span>
            <span class="extent">
                {{ActiveIndicator.measurementUnit}}
            </span>
        </div>

        <div class="content">
            <div class="list">
              <ng-container *ngFor="let range of ActiveIndicator?.ranges">

                <div class="item">
                    <div class="color" [style.background-color]="range.color"></div>
                    <span> {{range.name}} </span>
                </div>

              </ng-container>

            </div>

            <div class="values">
              <ng-container *ngFor="let range of ActiveIndicator?.ranges">
                  <span>{{range.minValue}} - {{range.maxValue}}</span>
              </ng-container>
            </div>

        </div>
    </div>

    </ng-container>

</div>




